import { mapByTemplate } from '../../utils/dto.mapper'
import { FileTypeEnum } from '../../common/interfaces'
import { ValidateAndReduceSettings } from '../../common/ScannerSettingValidators'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  scannerService,
  Scanner,
  ScanSettings,
  ScanResult,
} from '@services/ScannerService'
import { setServiceStatus } from '@state/reducers/scannerReducer'

export const discoverScanners = createAsyncThunk(
  'scanner/discoverScanners',
  async (params: void, { rejectWithValue }) => {
    try {
      const scanners: Scanner[] = await scannerService.DiscoverScanners()
      return scanners
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue('Failed to discover scanners')
    }
  },
)

export const startScannerService = createAsyncThunk(
  'scanner/initializeScannerService',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const isConnected = await scannerService.isScannerServiceWorking()
      if (isConnected) {
        dispatch(setServiceStatus(true))
        const scanners = scannerService.DiscoverScanners()
        return scanners
      } else {
        console.warn('NAPS2 service not available, using mock data')
        dispatch(setServiceStatus(false))
      }
    } catch (e: any) {
      console.error('Scanner service initialization error:', e)
      dispatch(setServiceStatus(false))
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue('Failed to initialize scanner service')
    }
  },
)

export const scanDocument = createAsyncThunk(
  'scanner/scanDocument',
  async (
    params: {
      deviceId: string
      settings?: Partial<ScanSettings>
    },
    { rejectWithValue },
  ) => {
    try {
      const { deviceId, settings } = params
      if (!deviceId) {
        return rejectWithValue('No scanner selected')
      }
      const scanSettings: ScanSettings = {
        deviceId,
        dpi: 300,
        colorMode: 'BlackAndWhite',
        format: 'pdf',
        paperSource: 'Flatbed',
        pageSize: 'A4',
        skipBlankPages: settings?.paperSource === 'duplex' ? true : false,
        blankThreshold: settings?.paperSource === 'duplex' ? 99 : 0,
        ...settings,
      }
      const result: ScanResult = await scannerService.scanDocument(scanSettings)
      return result
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue('Scan failed')
    }
  },
)

export const getScannerCapabilities = createAsyncThunk(
  'scanner/getScannerCapabilities',
  async (scannerId: string | null, { rejectWithValue }) => {
    try {
      const capabilities = await scannerService.getScannerCapabilities(
        scannerId,
      )
      return capabilities
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue('Failed to get scanner capabilities')
    }
  },
)

export const rotateScannedDocument = createAsyncThunk(
  'scanner/rotateScannedDocument',
  async (params: { Image: Blob; Angle: number }, { rejectWithValue }) => {
    try {
      const data = await scannerService.RotateDocument(
        params.Image as unknown as string,
        params.Angle,
      )
      console.log(data)
      return data
    } catch (e : any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue('Failed to get scanner capabilities')
    }
  },
)
